var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 7,
    viewBox: "0 0 6 6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.547 4.6h-.959c-.16 0-.288-.127-.288-.287V2.3H1.25c-.214 0-.32-.257-.17-.408L2.904.068c.09-.09.237-.09.327 0l1.824 1.824c.15.15.044.408-.17.408h-1.05v2.013c0 .16-.128.288-.287.288zm2.588-.095v1.342c0 .16-.129.288-.288.288H.287C.129 6.135 0 6.006 0 5.847V4.505c0-.16.128-.288.288-.288h1.629v.096c0 .37.3.671.671.671h.959c.37 0 .67-.3.67-.67v-.097h1.63c.16 0 .288.129.288.288zM4.649 5.56c0-.131-.108-.24-.24-.24s-.24.109-.24.24c0 .132.108.24.24.24s.24-.108.24-.24zm.767 0c0-.131-.108-.24-.24-.24s-.24.109-.24.24c0 .132.108.24.24.24s.24-.108.24-.24z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4eab9348449750c7c8d0b3f68f9fa269.svg";
export { ForwardRef as ReactComponent };